export default {
  txt: 'Congratulations, your application has been approved',
  shopName: 'Store Name',
  shopType: 'Store Type',
  date: 'Created time',
  loginNow: 'Log in now'
}
